import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ro from "./locales/ro/common.json";
import en from "./locales/en/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    fallbackLng: "ro",

    /** ⚙️ eliminat `lng: "ro"` ca să lase detectorul să decidă */
    interpolation: { escapeValue: false },

    detection: {
      /** Ordine clară: întâi verifică localStorage, apoi query, apoi navigator, apoi <html> */
      order: ["localStorage", "querystring", "navigator", "htmlTag"],
      /** Salvează limba selectată */
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

/** 🔄 Actualizează automat atributul <html lang="..."> la schimbarea limbii */
i18n.on("languageChanged", (lng: string) => {
  if (lng) {
    document.documentElement.setAttribute("lang", lng);
    localStorage.setItem("i18nextLng", lng);
  }
});

export default i18n;
